module.exports = __webpack_public_path__ + "static/media/400141_02.0a2938ad.png";